import React from 'react'

function Footer() {
  return (
    <div className='bg-gray-500 p-2 w-full text-white text-center'>Created by Nir</div>
  )
}

export default Footer